// extracted by mini-css-extract-plugin
export default {"page_content":"Home_page_content__BCC5h"};